import { Box, Grid, Stack, styled } from '@mui/material';
import { useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { IConsultant, IGlobalJobDTO } from 'wisestep-api';
import { SearchBar, WsButton, WsColors } from 'wisestep-base';

import JobPostersBulkEmail from '../../../../../components/BulkEmail/JobPostersBulkEmail';
import { emptyConsultantFilter } from '../../../helper/EmptyConsultantFilter';
import useConsultantsListing from '../../hooks/useConsultantsListing';

import ConsultantCard from './ConsultantCard';

type communicationProps = {
  selectedJobs: IGlobalJobDTO[];
};

const DrawerFooter = styled(Grid)(({ theme }) => ({
  position: 'fixed',
  backgroundColor: WsColors.TertiaryShades50,
  padding: theme.spacing(1),
  bottom: 1,
  width: '50vw',
}));

const Communication = ({ selectedJobs }: communicationProps) => {
  // const [filteredConsultants, setFilteredConsultants] = useState<IConsultant[]>(consultantsList);
  const [loader, setLoader] = useState<boolean>(false);
  const [consultantsList] = useConsultantsListing(emptyConsultantFilter, setLoader);
  const [selectedConsultants, setSelectedConsultants] = useState<
    (IConsultant & { isSelected: boolean })[]
  >([]);
  const [sendMail, setSendMail] = useState<boolean>(false);
  const methods = useForm();

  const addSelectedConsultant = (consultant: IConsultant & { isSelected: boolean }) => {
    if (!selectedConsultants.some((existing) => existing.id === consultant.id))
      selectedConsultants.push(consultant);
    else selectedConsultants.splice(selectedConsultants.indexOf(consultant), 1);
    setSelectedConsultants([...selectedConsultants]);
  };

  return sendMail ? (
    <JobPostersBulkEmail
      toEmailList={selectedJobs.map((job) => {
        const field = job.senderEmail ?? '';
        const maskedEmail =
          field.substring(0, 2) + 'xxxx@xxxxx' + field.substring(field.lastIndexOf('.'));
        return {
          email: job.senderEmail ? field : 'NotAvailable',
          text: maskedEmail,
        };
      })}
      jobs={selectedJobs}
      consultants={selectedConsultants}
      open={true}
      handleClose={() => {
        setSendMail(false);
        setSelectedConsultants([]);
      }}
      template={''}
    />
  ) : (
    <FormProvider {...methods}>
      <Box p={2}>
        <SearchBar name="consultantQuery" placeholder="Search for Consultants" />
      </Box>
      {!loader &&
        consultantsList.map((consultant) => (
          <Box mt={1} key={consultant.id}>
            <ConsultantCard
              consultant={consultant}
              checkBoxOnclick={() => addSelectedConsultant({ ...consultant, isSelected: true })}
              gridXs={4}
              isSelected={
                selectedConsultants.find((existing) => existing.id === consultant.id)?.isSelected ??
                false
              }
              isActiveCard={true}
              isCheckBox={true}
            />
          </Box>
        ))}

      <DrawerFooter>
        <Stack direction="row" alignItems="center" justifyContent="flex-end" spacing={2}>
          <WsButton
            onClick={() => {
              setSendMail(true);
              setSelectedConsultants([]);
            }}
          >
            Skip
          </WsButton>
          <WsButton onClick={() => setSendMail(true)}>Apply</WsButton>
        </Stack>
      </DrawerFooter>
    </FormProvider>
  );
};

export default Communication;
